import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { UserManager, UserManagerSettings, User } from 'oidc-client';

import { ConfigurationService } from '../shared/configuration/configuration.service';
import { WebRequestParameter } from '../shared/http/web-request-parameter';
import { InMemoryStorageService } from '../shared/storage/in-memory-storage.service';
import { LogOutService } from '../shared/logout/logout.service';

@Injectable()
export class AuthService {
  private manager: UserManager = new UserManager(getClientSettings());
  isAccessTokenExpiring: boolean = false;
  isSilentRenewInProgress: boolean = false;
  private user: User = null;

  constructor(private _config: ConfigurationService, private _http: HttpClient, private _storage: InMemoryStorageService, private logoutService: LogOutService) {

    this.manager.events.addUserLoaded(res => {
      if (res)
        this._storage.setItem("accessToken", res.access_token);
      this.isAccessTokenExpiring = false;
      if (this.isSilentRenewInProgress) {
        this.isSilentRenewInProgress = false;
      }
    });

    this.manager.events.addSilentRenewError(res => {
    });

    this.manager.events.addAccessTokenExpiring(res => {
      this.isAccessTokenExpiring = true;
    });

    //this.manager.events.addUserSignedOut(res => {
    //  this.logoutService.signOut().subscribe((response: any) => {
    //    window.location.href = response.logoutUrl;
    //  });
    //});

    this.manager.getUser().then(user => {
      this.user = user;
    });
  }

  isLoggedIn(): boolean {
    return this.user != null && !this.user.expired;
  }

  getClaims(): any {
    return this.user.profile;
  }

  getAuthorizationHeaderValue(): string {
    return `${this.user.token_type} ${this.user.access_token}`;
  }

  startAuthentication(): Promise<void> {
    return this.manager.signinRedirect();
  }

  signInSilent() {
    this.isSilentRenewInProgress = true;
    return this.manager.signinSilent();
  }

  get isLoginCallback() {
    return location.pathname.includes('login-callback');
  }

  completeAuthentication(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.manager.signinRedirectCallback().then(user => {

        this.user = user;
        this._storage.setItem("accessToken", this.user.access_token);
        console.log(user.profile);
      
        const webRequestParameter = new WebRequestParameter('/users/details');
        webRequestParameter.headers = webRequestParameter.headers || new HttpHeaders();
        webRequestParameter.headers = webRequestParameter.headers.set('Content-Type', 'application/json');
        webRequestParameter.headers = webRequestParameter.headers.set('Authorization', 'Bearer ' + user.access_token);

        console.log(user.profile.upn);



        this._http
          .post<any>(webRequestParameter.url, { upn: user.profile.upn }, { headers: webRequestParameter.headers, observe: 'response' })
          .subscribe(result => {
            this._storage.setItem("loggedInUserInfoEncrypted", result.body.userInfoJson);
            this._storage.setItem("loggedInUserInfo", result.body.userDetails);
            resolve();
          }, error => {
            this.user = null;
           resolve(error);
          }
          );
      });
    });
  }
}

export function getClientSettings(): UserManagerSettings {
  var stsConfig = JSON.parse((window as any).appConfig).stsSetting;
  var link = location.protocol + '//' + location.hostname;
  if (location.port && location.port.length > 0) {
    link = link + ':' + location.port;
  }

  return {
    authority: stsConfig.stsEndpoint,
    client_id: stsConfig.appClientId,
    redirect_uri: link + '/login-callback',
    post_logout_redirect_uri: link + '/sign-out',
    response_type: "id_token token",
    scope: stsConfig.appScopes,
    filterProtocolClaims: true,
    loadUserInfo: true,
    automaticSilentRenew: false,
    accessTokenExpiringNotificationTime: 60,
    silent_redirect_uri: link + '/silent-refresh.html'
  };
}



// WEBPACK FOOTER //
// ./src/app/startup/auth.service.ts